export function catalogListGridClassName(isDesktop) {
	return [
		"grid w-full items-stretch gap-5",
		isDesktop ? "grid-cols-4" : "grid-cols-1",
		"[&>*]:min-w-0 [&>*]:h-full",
	].join(" ");
}

export default function CatalogListGrid({ isDesktop, children, className = "" }) {
	return (
		<div
			dir="rtl"
			className={[
				catalogListGridClassName(isDesktop),
				"[&>*]:min-w-0",
				className,
			]
				.filter(Boolean)
				.join(" ")}
		>
			{children}
		</div>
	);
}
